import { axiosInstance } from './instance';

/** POST create returns BasicResponse: { message, response: { id } | Promotion } */
const parsePromotionIdFromResponse = (data) => {
    if (!data) return null;
    const nested = data.response;
    if (nested && typeof nested === 'object' && nested.id) {
        return nested.id;
    }
    if (data.id) return data.id;
    if (typeof nested === 'string') return nested;
    return null;
};

const getPromotionsService = (storeId) => {
    return axiosInstance.get(`/stores/${storeId}/promotions`);
};

const getPromotionService = (storeId, promotionId) => {
    return axiosInstance.get(`/stores/${storeId}/promotions/${promotionId}`);
};

const createPromotionService = (storeId, data) => {
    return axiosInstance.post(`/stores/${storeId}/promotions`, data);
};

const updatePromotionService = (storeId, promotionId, data) => {
    return axiosInstance.put(`/stores/${storeId}/promotions/${promotionId}`, data);
};

const deletePromotionService = (storeId, promotionId) => {
    return axiosInstance.delete(`/stores/${storeId}/promotions/${promotionId}`);
};

const applyPromotionProductsService = (storeId, promotionId, data) => {
    return axiosInstance.put(`/stores/${storeId}/promotions/${promotionId}/products`, data);
};

const pollPromotionUntilSettled = async (
    storeId,
    promotionId,
    { intervalMs = 2000, maxAttempts = 90 } = {}
) => {
    for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
        const { data } = await getPromotionService(storeId, promotionId);
        if (data.status === 'applied' || data.status === 'failed') {
            return data;
        }
        if (data.status !== 'applying') {
            return data;
        }
        await new Promise((resolve) => setTimeout(resolve, intervalMs));
    }
    const { data } = await getPromotionService(storeId, promotionId);
    return data;
};

export {
    getPromotionsService,
    getPromotionService,
    createPromotionService,
    updatePromotionService,
    deletePromotionService,
    applyPromotionProductsService,
    pollPromotionUntilSettled,
    parsePromotionIdFromResponse,
};
